export enum PaymentMethodEnum {
  Blik = 'blik',
  Card = 'card',
  IngOnlineTransfer = 'ing',
  OnlineTransfer = 'pbl',
  PayLater = 'imoje_paylater',
  WireTransfer = 'wt',
}

export enum PaymentMethodCodeEnum {
  PayPo = 'paypo',
  GPay = 'gpay',
  ApplePay = 'applepay',
}
